// extracted by mini-css-extract-plugin
module.exports = {"stampBtn":"_4CEh1EAsRCUXOFDk7S57o"};